export default __webpack_public_path__ + "static/media/selecta_main_large.49fb780a.jpg";